class PandaSet<T extends UniqIdMarked> {

	public constructor(name:string = 'unnamed') {
		this._name = name;
	}

	public hash:{[key:string]:T} = {};
	private _name:string;

	public addObject(obj:T):void {
		this.hash[obj.uniqId] = obj;
	}

	public removeObject(obj:T):void {
		let objInHash:T = this.hash[obj.uniqId];
		PandaConsole.here;

		if (!objInHash) {
			PandaConsole.errorUncritical(new PandaError('Set ' + this._name + ' attemp to remove without object'));
		}

		delete this.hash[obj.uniqId];
	}

	public hasObject(obj:T):boolean {
		return !!this.hash[obj.uniqId];
	}

	public isEmpty():boolean {
		for (let key in this.hash) {
			return false;
		}
		return true;
	}
}